import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type ResolveFn, type RouterStateSnapshot } from '@angular/router';
import { TuiDialogService } from '@taiga-ui/core';
import { catchError, forkJoin, map, of } from 'rxjs';

import type { NotificationData } from '../types';

import { useApiGetGsnb } from '../api';
import { useApiGetBusinessLicensePending } from '../api/channel/use-business-license-pending.api';
import { useApiGetH5businessLicenseInfo } from '../api/channel/use-business-licenseInfo-sheet.api';
import { TaxUserService } from '../service';
import {
  formatQuarterList,
  getAnnualInspectionData,
  getAuthenticationData,
  getSubmissionOverdueData,
  replaceTpl,
} from './notification-pend.data';

export const NotificationPendTitleResolver: ResolveFn<string> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  console.log('NotificationPendTitleResolver route', route);
  const pend = route.queryParams['pend'];
  if (!pend) return '通知待办';
  switch (pend) {
    // case 'abnormalEnterprise':
    //   return '其它企业异常待处理';
    case 'annualInspection':
      return '工商年检待办';
    case 'authentication':
      return '电子税务局app实名认证待办';
    case 'submissionOverdue':
      return '逾期申报处理';
    default:
      return '通知待办';
  }
};

export const NotificationPendResolver: ResolveFn<NotificationData | null> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  console.log('invoiceResolver', route, state);
  const userSrv = inject(TaxUserService);
  const pend = route.queryParams['pend'];
  const dialogService = inject(TuiDialogService);
  const apis = {
    getH5businessLicenseInfo: useApiGetH5businessLicenseInfo().api,
    getGsnb: useApiGetGsnb().api,
    getBusinessLicensePending: useApiGetBusinessLicensePending().api,
  };
  const pendingData = () => {
    const userBizInfo = userSrv.userBizInfo();
    const idCard = userBizInfo?.idNumber ?? '';
    const mobile = userBizInfo?.phoneNumber ?? '';
    return apis.getBusinessLicensePending({ idCard, mobile }).pipe(
      catchError(() => of({ code: '', data: undefined, msg: '' })),
      map((res) => res.data),
    );
  };
  const defaultDataAndRes = () => {
    return pendingData().pipe(
      map((res) => {
        if (res?.notificationEnum !== 'CREATED') return {};
        try {
          return {
            data: JSON.parse(res.notificationContent || '{}'),
            pendinfo: res,
          };
        } catch {
          throw new Error('获取通知内容失败');
        }
      }),
    );
  };
  const defaultData = () => {
    return defaultDataAndRes().pipe(map(({ data }) => data));
  };
  let request$;
  if (!pend) {
    request$ = defaultData();
  }
  switch (pend) {
    // case 'abnormalEnterprise':
    //   return defaultDataAndRes().pipe(
    //     map(({ data, pendinfo }) => {
    //       try {
    //         if (pendinfo?.enterpriseAnomalyMsg) {
    //           data.content = `${data.content}<p> <div  class="flex  flex-col"> <div class="font-bold">企业异常信息：</div> <div style='color:red;margin:0;margin-top:4px;'>${pendinfo?.enterpriseAnomalyMsg}</div></div> </p>`;
    //           // if (isHtmlString(data.content)) {
    //           //   data.content = `${data.content}<p style='color:red;margin:0;margin-top:4px;'>${res?.enterpriseAnomalyMsg}</p>`;
    //           // } else {
    //           //   data.content = `${data.content}<p style='color:red;margin:0;margin-top:4px;'>${res?.enterpriseAnomalyMsg}</p>`;
    //           // }
    //         }
    //         return data;
    //       } catch {
    //         return {};
    //       }
    //     }),
    //   );
    case 'annualInspection':
      // if (!userSrv.associationId()) return defaultData();

      // 工商年检
      request$ = forkJoin([
        apis
          .getH5businessLicenseInfo({
            businessLicenseInfoSheetId: userSrv.associationId(),
          })
          .pipe(map((res) => res.data)),
        apis.getGsnb({ socialCreditCode: userSrv.userBizInfo()?.creditCode || '' }).pipe(map((res) => res.data)),
      ]).pipe(
        map(([businessLicenseInfoSheetDTO, ldGsnbDto]) => {
          const pageData = getAnnualInspectionData().data;

          const apiData = {
            year: ldGsnbDto?.[0]?.year,
            deadline: ldGsnbDto?.[0]?.planCompleteTime,
            userName: businessLicenseInfoSheetDTO?.serviceUserName,
            userPhone: businessLicenseInfoSheetDTO?.serviceUserPhone,
          };

          pageData.content = replaceTpl(pageData.content, apiData);
          if (apiData.year) {
            pageData.actions![0].url = `/annual-report-detail?year=${apiData.year}`;
          } else {
            pageData.actions![0].url = '/annual-report-list';
          }
          // if (isHtmlString(data.content)) {
          //   data.content = `${data.content}<p style='color:red;margin:0;margin-top:4px;'>${res?.enterpriseAnomalyMsg}</p>`;
          // } else {
          //   data.content = `${data.content}<p style='color:red;margin:0;margin-top:4px;'>${res?.enterpriseAnomalyMsg}</p>`;
          // }
          return pageData;
        }),
      );
      break;
    case 'authentication':
      request$ = of(getAuthenticationData().data);
      break;
    case 'submissionOverdue':
      request$ = apis
        .getH5businessLicenseInfo({
          businessLicenseInfoSheetId: userSrv.associationId(),
        })
        .pipe(
          map((res) => res.data),
          map((res) => {
            const pageData = getSubmissionOverdueData().data;
            const quarter = route.queryParams['quarter'];
            const apiData = { quarter: formatQuarterList(quarter), userName: res?.serviceUserName, userPhone: res?.serviceUserPhone };
            pageData.content = replaceTpl(pageData.content, apiData);
            return pageData;
          }),
        );
      break;
    default:
      request$ = defaultData();
      break;
  }
  return request$.pipe(
    catchError((err) => {
      dialogService
        .open(err.message, {
          label: '提示',
          appearance: 'center-dialog',
          closeable: false,
          dismissible: false,
          data: {
            button: '知道了',
          },
        })
        .subscribe();
      console.error('NotificationPendResolver err', err);
      return of(null);
    }),
  );
};
function isHtmlString(str: string): boolean {
  if (!str || typeof str !== 'string') return false;

  const doc = new DOMParser().parseFromString(str, 'text/html');
  // 如果解析后有实际元素，说明是合法 HTML
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
}
